// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== FIXED TERMS MODAL (non-conflicting) ===== */

.terms-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999 !important;
}

.terms-modal {
  background: #fff;
  width: 90%;
  max-width: 520px;
  padding: 32px;
  border-radius: 14px;
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.25);
  animation: fadeInScale 0.25s ease-out;
  position: relative;
  z-index: 10000 !important;
}

.terms-modal h2 {
  margin-top: 0;
  margin-bottom: 16px;
  color: #0d6832; /* Clean green professionally */
  font-size: 24px;
  font-weight: 700;
}

.terms-modal p {
  font-size: 16px;
  color: #333;
  margin-bottom: 12px;
}

.terms-modal ul {
  margin-left: 18px;
  margin-bottom: 20px;
}

.terms-modal li {
  margin-bottom: 8px;
  font-size: 15px;
}

.checkbox-section {
  display: flex;
  align-items: center;
  margin-bottom: 22px;
}

.checkbox-section input {
  transform: scale(1.2);
  margin-right: 10px;
}

.agree-button {
  width: 100%;
  padding: 12px 0;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  background: #0d6832;
  color: #fff;
  transition: 0.25s all ease;
}

.agree-button:disabled {
  background: #b5b5b5;
  cursor: not-allowed;
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.92);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TermsModal.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc,EAAE,+BAA+B;EAC/C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":["/* ===== FIXED TERMS MODAL (non-conflicting) ===== */\n\n.terms-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999 !important;\n}\n\n.terms-modal {\n  background: #fff;\n  width: 90%;\n  max-width: 520px;\n  padding: 32px;\n  border-radius: 14px;\n  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.25);\n  animation: fadeInScale 0.25s ease-out;\n  position: relative;\n  z-index: 10000 !important;\n}\n\n.terms-modal h2 {\n  margin-top: 0;\n  margin-bottom: 16px;\n  color: #0d6832; /* Clean green professionally */\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.terms-modal p {\n  font-size: 16px;\n  color: #333;\n  margin-bottom: 12px;\n}\n\n.terms-modal ul {\n  margin-left: 18px;\n  margin-bottom: 20px;\n}\n\n.terms-modal li {\n  margin-bottom: 8px;\n  font-size: 15px;\n}\n\n.checkbox-section {\n  display: flex;\n  align-items: center;\n  margin-bottom: 22px;\n}\n\n.checkbox-section input {\n  transform: scale(1.2);\n  margin-right: 10px;\n}\n\n.agree-button {\n  width: 100%;\n  padding: 12px 0;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  cursor: pointer;\n  background: #0d6832;\n  color: #fff;\n  transition: 0.25s all ease;\n}\n\n.agree-button:disabled {\n  background: #b5b5b5;\n  cursor: not-allowed;\n}\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.92);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
